import React, { useState, useEffect, useRef } from "react";
import { ChevronDownIcon } from "@heroicons/react/16/solid";

export default function SelectInputHolder({ input, onUpdate }: any) {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selectedValues, setSelectedValues] = useState<any>([]);
    const dropdownRef = useRef(null);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        // Update the state based on whether there is input
        setSelectedValues(event.target.value);
        onUpdate(event.target.name, event.target.value);
        setDropdownOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                dropdownRef.current &&
                !(dropdownRef.current as HTMLElement).contains(
                    event.target as Node
                )
            ) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className={`relative w-full sm:px-4 group ${dropdownOpen ? "z-50" : ""}`} ref={dropdownRef}>
            <div className="relative flex flex-col cursor-pointer">
                <div
                    className={`relative text-white border w-full py-[0.7rem] px-[2rem] rounded-full z-10 cursor-pointer flex ${
                        dropdownOpen ? "border-0 z-[9999]" : ""
                    }`}
                    onClick={() => {
                        setDropdownOpen(!dropdownOpen);
                    }}
                >
                    <span className="relative duration-150 select-none w-full">
                        {selectedValues.length > 0 ? (
                            <span
                                className={`${
                                    !dropdownOpen ? "inline-block" : "opacity-0"
                                }`}
                            >
                                {selectedValues}
                            </span>
                        ) : (
                            <span
                                className={`${
                                    !dropdownOpen
                                        ? "inline-block opacity-70"
                                        : "opacity-0"
                                }`}
                            >
                                {input.label}
                            </span>
                        )}
                        <ChevronDownIcon
                            className={`absolute h-5 w-5 top-0 bottom-0 right-0 m-auto ${
                                dropdownOpen
                                    ? "transform rotate-180 text-black"
                                    : ""
                            }`}
                        />
                    </span>
                </div>
                <div
                    className={`absolute top-8 py-3 px-[2rem] border border-b-0 w-full -translate-y-8 bg-white rounded-3xl ${
                        dropdownOpen
                            ? "opacity-100 pointer-events-all z-[9999]"
                            : "opacity-0 pointer-events-none z-0"
                    }`}
                >
                    <div className="mb-4 select-none">
                        Choose the most relevant option
                    </div>
                    {/* {input.optionsArray.map((item: any, i: number) => {
                        const uniqueId = `${input.name}-${i}`;
                        return (
                            <div key={i} className="flex">
                                <input
                                    type="radio"
                                    id={uniqueId}
                                    name={input.name}
                                    value={item.value}
                                    className="hidden"
                                    onChange={(e) => {
                                        handleInputChange(e);
                                    }}
                                />
                                <label
                                    htmlFor={uniqueId}
                                    className="cursor-pointer flex items-center"
                                >
                                    <span
                                        className={`border-[1px] border-black w-4 h-4 inline-block mr-2 rounded-sm relative ${
                                            item.value === selectedValues
                                                ? "opacity-100 bg-blue border-blue"
                                                : "opacity-60"
                                        }`}
                                    >
                                        {item.value === selectedValues && (
                                            <svg
                                                className="absolute top-0 left-0 w-full h-full text-white"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={4}
                                                    d="M5 13l4 4L19 7"
                                                />
                                            </svg>
                                        )}
                                    </span>
                                    {item.label}
                                </label>
                            </div>
                        );
                    })} */}
                    {input.optionsArray.map((item: any, i: number) => {
                        const uniqueId = `${input.name}-${i}`;
                        return (
                            <div key={i} className="flex">
                                <input
                                    type="radio"
                                    id={uniqueId}
                                    name={input.name}
                                    value={item.value}
                                    className="custom-checkbox"
                                    onChange={(e) => {
                                        handleInputChange(e);
                                    }}
                                />
                                <label
                                    htmlFor={uniqueId}
                                    className="cursor-pointer flex items-center"
                                >
                                    <span
                                        className={`w-4 h-4 inline-block mr-2`}
                                    ></span>
                                    {item.label}
                                </label>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
